import { create } from "zustand";
import { Brand, SERVER_DOMAINS } from "shared/constants/brands";
import { HostType } from "shared/types/HostsType";
import { getHostByUrl } from "shared/utils";

interface SharedState {
  brand: Brand | null;
  host: HostType | null;
  serverDomain: string | null;
  updateBrand: (brand: Brand) => void;
  updateHost: (url: string) => void;
}

export const useSharedStore = create<SharedState>((set) => ({
  brand: null,
  host: null,
  serverDomain: null,
  updateBrand: (brand: Brand) =>
    set({ brand, serverDomain: SERVER_DOMAINS[brand] || null }),
  updateHost: (url: string) => {
    return getHostByUrl(url);
  },
}));
